import { NavValues, NavResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateNav(values: NavValues, t?: ToolsTranslations['nav']): NavResult {
  const { totalAssets, totalLiabilities, outstandingShares } = values;

  // Validation
  if (totalAssets < 0) {
    return { nav: null, netAssets: null, isValid: false, message: t?.invalid.totalAssets };
  }
  if (totalLiabilities < 0) {
    return { nav: null, netAssets: null, isValid: false, message: t?.invalid.totalLiabilities };
  }
  if (outstandingShares <= 0) {
    return { nav: null, netAssets: null, isValid: false, message: t?.invalid.outstandingShares };
  }

  // Calculate net assets (Total Assets - Total Liabilities)
  const netAssets = totalAssets - totalLiabilities;
  
  // Calculate NAV (Net Assets / Outstanding Shares)
  const nav = netAssets / outstandingShares;
  
  // Round to 2 decimal places
  const roundedNav = Math.round(nav * 100) / 100;
  const roundedNetAssets = Math.round(netAssets * 100) / 100;

  // Check for valid results
  if (!isFinite(roundedNav) || !isFinite(roundedNetAssets)) {
    return { nav: null, netAssets: null, isValid: false, message: t?.invalid.generic };
  }

  return { 
    nav: roundedNav, 
    netAssets: roundedNetAssets, 
    isValid: true 
  };
}
